import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { name: String, props: Object }

  capture() {
    window.posthog?.capture(this.nameValue, this.propsValue)
  }
}
